export default "__VITE_ASSET__D5nHUe9N__"